// "Today's figures are only current to the last pull" — the reporting dashboard's
// freshness caveat, shown ONLY when the selected range includes today.
//
// ⚠️ Read `src/lib/reporting/pullFreshness.ts` for why this exists. Short version:
// the Meta pull runs 2-hourly, so a range containing today is ALWAYS partial, and
// an empty morning is otherwise indistinguishable from a period nobody has pulled
// yet. BOTH the decision (whether to speak, and which case) and the WORDING are
// pure and tested there — the ConversionNote precedent — so this file is only the
// timestamp formatting and the markup.

import { cn } from '../../lib/utils';
import {
  pullFreshnessMessage,
  type PullFreshnessNotice,
} from '../../lib/reporting/pullFreshness';

export function PullFreshnessNote({
  notice,
  className,
}: {
  notice: PullFreshnessNotice | null;
  className?: string;
}): React.JSX.Element | null {
  if (!notice) return null;
  return (
    <p className={cn('text-xs text-muted-foreground', className)} data-testid="pull-freshness-note">
      {pullFreshnessMessage(notice, (iso) => new Date(iso).toLocaleString())}
    </p>
  );
}
